import { render } from "./DocUpload.vue?vue&type=template&id=fac7efd6"
import script from "./DocUpload.vue?vue&type=script&lang=js"
export * from "./DocUpload.vue?vue&type=script&lang=js"

import "./DocUpload.vue?vue&type=style&index=0&id=fac7efd6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__